import React from 'react';
import { bool, func, string } from 'prop-types';
import './loadingPopup.scss';

// devExtreme
import { Button } from 'devextreme-react';

// components
import Spinner from '../../Spinner/Spinner';

const LoadingPopup = ({
  onBtnClick,
  darkModeEnabled = false,
  title = 'Przetwarzam dane',
  cancelTxt = 'Anuluj'
}) => (
  <div className={`loadingxls ${!darkModeEnabled ? 'loadingxls--white' : ''}`}>
    <div className="loadingxls__content dx-card">
      <span className="loadingxls__content__tytul">{title}</span>
      <div className="loadingxls-spinner-wrapper">
        <Spinner />
      </div>
      {onBtnClick && (
        <Button
          type="normal"
          onClick={onBtnClick}
          stylingMode="contained"
          text={cancelTxt}
        />
      )}
    </div>
  </div>
);

LoadingPopup.propTypes = {
  onBtnClick: func,
  darkModeEnabled: bool,
  title: string,
  cancelTxt: string
};

export default LoadingPopup;
